import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Flame, ArrowUpRight, Calendar } from "lucide-react";
import SponsorBadge from "@/components/SponsorBadge";

export default function DailyBanner() {
  const [daily, setDaily] = useState(null);

  useEffect(() => {
    api.get("/daily").then((r) => setDaily(r.data)).catch(() => {});
  }, []);

  if (!daily) return null;

  return (
    <Link
      to={`/challenges/${daily.id}`}
      className="block card p-6 md:p-8 group relative overflow-hidden"
      style={{ borderColor: "rgba(37,99,235,0.4)" }}
      data-testid="daily-banner"
    >
      <div className="absolute inset-0 pointer-events-none" style={{
        background: "radial-gradient(circle at 0% 0%, rgba(37,99,235,0.12), transparent 50%), radial-gradient(circle at 100% 100%, rgba(220,38,38,0.10), transparent 50%)",
      }} />
      <div className="relative flex items-start justify-between gap-6 flex-wrap">
        <div className="flex-1 min-w-[260px]">
          <div className="flex items-center gap-3 mb-3 flex-wrap">
            <span className="tag flex items-center gap-1.5" style={{ background: "rgba(37,99,235,0.12)", borderColor: "rgba(37,99,235,0.4)", color: "#93c5fd" }}>
              <Flame size={11} /> Daily Challenge
            </span>
            <span className="label-mono flex items-center gap-1.5">
              <Calendar size={11} /> {daily.date}
            </span>
            {daily.sponsor && <SponsorBadge sponsor={daily.sponsor} compact />}
            {daily.user_vote && (
              <span className={`tag ${daily.user_correct ? "tag-correct" : "tag-wrong"}`}>
                {daily.user_correct ? "Voted · streak alive" : "Voted"}
              </span>
            )}
          </div>
          <div className="font-display font-bold text-2xl md:text-3xl tracking-tight">
            {daily.title}
          </div>
          {daily.hook && (
            <p className="mt-2 text-sm md:text-base" style={{ color: "var(--text-dim)" }}>
              {daily.hook}
            </p>
          )}
        </div>
        <div className="btn btn-primary group-hover:translate-x-0.5 transition-transform" data-testid="daily-cta">
          {daily.user_vote ? "Open result" : "Vote today"} <ArrowUpRight size={14} />
        </div>
      </div>
    </Link>
  );
}
